import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Statistics = styled('section')(() => ({}));

export const Cards = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '564fr 418fr 710fr',
  gridTemplateRows: 'auto auto auto',
  gap: '20px',
  width: '100%',
  margin: '0 auto',

  [theme.breakpoints.down('2xl')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
  },
  [theme.breakpoints.down('xl')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'auto',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(1, 1fr)',
  },
}));

export const Card = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  gap: '20px',
  padding: '44px',
  borderRadius: '24px',
  backgroundColor: theme.palette.color.global.card,

  '&:nth-of-type(1)': {
    gridColumn: 1,
    gridRow: 1,

    [theme.breakpoints.down('xl')]: {
      gridColumn: 'auto',
      gridRow: 'auto',
    },
  },
  '&:nth-of-type(2)': {
    gridColumn: 2,
    gridRow: '1 / span 3',

    [theme.breakpoints.down('xl')]: {
      gridColumn: 'auto',
      gridRow: 'auto',
      order: 1,
    },
  },
  '&:nth-of-type(3)': {
    gridColumn: 3,
    gridRow: '1 / span 3',

    [theme.breakpoints.down('xl')]: {
      gridColumn: 'auto',
      gridRow: 'auto',
      order: 2,
    },
  },
  '&:nth-of-type(4)': {
    gridColumn: 1,
    gridRow: '2 / span 2',

    [theme.breakpoints.down('xl')]: {
      gridColumn: 'auto',
      gridRow: 'auto',
    },
  },

  [theme.breakpoints.down('2xl')]: {
    padding: '32px',
  },
  [theme.breakpoints.down('xl')]: {
    padding: '28px',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '24px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
  },
}));

export const Text = styled(Typography)({});

export const Bottom = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'end',
  gap: '22px',

  [theme.breakpoints.down('2xl')]: {
    flexWrap: 'wrap',
    gap: '24px',
  },
}));

export const Info = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  gap: '8px',
}));

export const InfoSub = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',

  [theme.breakpoints.down('2xl')]: {
    flexWrap: 'wrap',
  },
}));

export const Review = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',

  [theme.breakpoints.down('2xl')]: {
    width: '100%',
    gap: '16px',
  },
}));

export const Value = styled(Typography)(() => ({}));

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.color.fg.primary,

  [theme.breakpoints.down('xl')]: {
    width: '100%',
  },
}));

export const Stars = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));

export const Star = styled('img')(() => ({
  flexShrink: 0,
  width: '26px',
  height: '26px',
}));
